define('drops/treeView_v2/treeView_v2',[
    'jquery',
    'underscore',
    'lq',
    'tabulator',
    'lq/style',
    'lq/html',
    'lq/tooltip',
    'lq/drop',
    'lq/required',
    'lq/dynamicContentImage',
    'lq/parameterBinding'
], function ($, _, lq, Tabulator, Style, html, Tooltip, Drop, Required, dynamicContentImage, parameterBinding) {
    'use strict';

    var defaults = {
        data: {
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            selectionMode: 'none',
            headerVisible: false,
            keepScrollPositionOnQueryReload: false,
            expandTreeOnLoad: true,
            childIndent: 15,
            treeControlColumn: 0
        }
    };

    var capitalize = function (str) {
        return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
    };

    var hasContent = function (obj) {
        return !_.isEmpty(obj);
    };

    var setBackgroundImage = function ($el, physicalFile) {
        var background = ''
        if (physicalFile && physicalFile !== '') {
            var url = lq.getTenantUploads(physicalFile);
            background = url
                ? 'url(' + url + ')'
                : '';
        }
        $el.css('background-image', background);
    };

    var horizontalAlignmentToFlex = {
        inherit: 'flex-start',
        left: 'flex-start',
        center: 'center',
        right: 'flex-end'
    };

    function TreeView(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.$tree = $('<div/>');
        this.$element.append(this.$tree);

        this.$element
            .css({
                boxSizing: 'border-box'
            });

        this.activeFilters = {};

        this.resizeObserver = new ResizeObserver(_.debounce(() => {
            this.resizeTree();
        }, 100));

        this.resizeObserver.observe(this.$element[0]);

        Style.renderStyles(this, null, this.$element, this.data.styles);
    };

    Drop.extend(TreeView, Drop);

    TreeView.typeName = 'TreeView_v2';

    TreeView.prototype.initializeTree = function () {
        var columns = this.buildColumnDefinitions();
        var config = this.buildTabulatorConfig(columns);

        this.tableInstance = new Tabulator(this.$tree[0], config);

        this.setupTableEventHandlers();
    };

    TreeView.prototype.buildColumnDefinitions = function() {
        var self = this;
        var columns = [];
        self._autoSpanCols = [];

        _.each(this.data.columns, function (column, index) {
            if (column.autoSpanEnabled) self._autoSpanCols.push(index);
            if (self.mergesIntoNextColumn(column, index)) return;

            var colDef = {
                title: column.headerVisible ? column.headerText : '',
                field: String(index),
                headerHozAlign: column.headerContentAlignment,
                headerSort: false,
                resizable: false,
                vertAlign: column.verticalAlign || 'middle',
                hozAlign: column.horizontalAlign || 'left',
                formatter: function (cell) {
                    var el = cell.getElement();
                    var data = cell.getData();
                    var colField = cell.getColumn().getField();

                    var bg = data._backgroundColors && data._backgroundColors[parseInt(colField)];
                    el.style.backgroundColor = bg || '';

                    return cell.getValue();
                },
                cellClick: function(e, cell){
                    if (self.designData || !column.eventing || !self.isTextColumn(column)) return;

                    var data = cell.getData();
                    var $cellEl = $(cell.getElement());
                    self.triggerCellEventsIfEnabled("clicked", column, data._eventArg, $cellEl);
                }
            };

            if (column.useTextFilter)
                parameterBinding.initializeUpdates(
                    self,
                    column.textFilter,
                    function(value) {
                        self.applyFilter(value, String(index));
                    }
                );

            if (column.type === 'Static Text' || column.type === 'Dynamic Text')
                colDef.cssClass = column.textTrimStyle === 'Dynamic Height' ? 'tabulator-wrap-lines' : '';

            if (column.columnSizeType === 'pixels') {
                colDef.width = column.columnSize;
                colDef.minWidth = column.columnSize + 'px';
            } else if (column.columnSizeType === 'fractions') {
                colDef.widthGrow = column.columnSize || 1;
            }

            columns.push(colDef);
        });

        return columns;
    };

    TreeView.prototype.buildTabulatorConfig = function(columns) {
        var self = this;

        return {
            data: [],
            index: "id",
            columns: columns,
            layout: "fitColumns",
            dataTree: true,
            dataTreeFilter: true,
            dataTreeSort: false,
            renderVertical: 'basic',
            headerVisible: this.data.headerVisible && !this.isMobileLayout(),
            dataTreeStartExpanded: this.data.expandTreeOnLoad,
            dataTreeBranchElement: false,
            dataTreeChildField: "_children",
            dataTreeChildIndent: this.data.childIndent,
            dataTreeElementColumn: String(this.getTreeControlColumnIndex()),
            selectableRows: this.data.selectionMode === 'none' ? false : this.data.selectionMode === 'multi' ? true : 1,
            rowFormatter: function (row) {
                var data = row.getData();
                var el = row.getElement();

                if (self.isMobileLayout())
                    self.applyMobileIndent(row);

                el.classList.toggle('tabulator-row-mobile', self.isMobileLayout());
                el.classList.toggle('tabulator-leaf', !data._children);

                if (hasContent(self.data.eventing))
                    el.classList.add('tabulator-event');

                el.classList.toggle('tabulator-disabled', hasContent(self.activeFilters) && !data._filterMatch);

                if (!self._autoSpanCols.length || self.isMobileLayout()) return;

                var cells = row.getCells();
                for (let k = 0; k < self._autoSpanCols.length; k++) {
                    var i = self._autoSpanCols[k];
                    var cellEl = cells[i].getElement();
                    if (!cellEl) continue;

                    cellEl.style.flex = '1 1 auto';
                    cellEl.style.width = 'auto';
                    cellEl.style.minWidth = '0';

                    var continueAutoSpan = true;
                    for (let j = i + 1; j < cells.length; j++) {
                        var next = cells[j].getElement();
                        var visible = next.querySelector(':not(.tabulator-hidden-content)');
                        if (continueAutoSpan && !visible) {
                            next.style.display = 'none';
                        } else {
                            continueAutoSpan = false;
                            next.style.display = 'inline-flex';
                        }
                    }
                }
            }
        };
    };

    TreeView.prototype.setupTableEventHandlers = function() {
        var self = this;

        this.tableInstance.on("tableBuilt", function(){
            setTimeout(function() { self.resizeTree() }, 0);

            // monkey patch to prevent scroll from resetting to 0 when expanding/collapsing rows
            if (self.tableInstance.rowManager && self.tableInstance.rowManager.renderer) {
                var renderer = self.tableInstance.rowManager.renderer;
                var proto = renderer.constructor.prototype;

                if (self.tableInstance.options.renderVertical !== 'basic') return;

                if (!proto._safeScrollPatchApplied) {
                    proto._origClearRows = proto._origClearRows || proto.clearRows;
                    proto._origRerenderRows = proto._origRerenderRows || proto.rerenderRows;

                    proto.clearRows = function () {
                        if (!this._preserveScroll)
                            return proto._origClearRows.call(this);

                        var element = this.tableElement;
                        while (element.firstChild) element.removeChild(element.firstChild);

                        element.style.minWidth = "";
                        element.style.minHeight = "";
                        element.style.display = "";
                        element.style.visibility = "";
                    };

                    proto.rerenderRows = function (callback) {
                        this._preserveScroll = true;
                        try {
                            return proto._origRerenderRows.call(this, callback);
                        } finally {
                            this._preserveScroll = false;
                        }
                    };

                    proto._safeScrollPatchApplied = true;
                }

                renderer._preserveScroll = false;
            }

            self.tableInstance.getColumns().forEach(column => {
                var headerEl = column.getElement().querySelector(".tabulator-col-title");

                var def = column.getDefinition();
                var columnConfig = self.data.columns[def.field];
                if (columnConfig.applyCustomPaddingForHeader && columnConfig.customPaddingForHeader)
                    $(headerEl)
                        .css({
                            padding: self.getPaddingFormat(columnConfig.customPaddingForHeader)
                        });

                if (headerEl.querySelector(".custom-tooltip") || !self.data.columns) return;

                if (!columnConfig || !columnConfig.headerTooltip) return;

                var tooltip = new Tooltip(self, columnConfig.headerTooltip, $(headerEl));
                tooltip.update();

                tooltip.$element.addClass("custom-tooltip");
            });
        });

        this.tableInstance.on("rowSelectionChanged", function(data, rows, selected, deselected) {
            self.updateRequiredIndicator();
        });

        this.tableInstance.on("rowClick", function(e, row) {
            if (self.isMobileLayout() && row.getData()._children && !e.target.closest('.tabulator-text-column-event')) row.treeToggle();
            self.triggerRowEvents('clicked', row);
        });

        this.tableInstance.on("rowSelected", function(row) {
            self.triggerRowEvents('selected', row);
        });

        this.tableInstance.on("rowDeselected", function(row) {
            self.triggerRowEvents('deselected', row);
        });

        if (this.isEventEnabled("someRootNodesAreExpanded"))
            this.tableInstance.on("dataTreeRowExpanded", function (_, level) {
                if (level !== 0) return;
                if (++self.openRootNodesCount === 1)
                    self.someRootNodesAreExpanded();
            });

        if (this.isEventEnabled("allRootNodesAreCollapsed"))
            this.tableInstance.on("dataTreeRowCollapsed", function (_, level) {
                if (level !== 0) return;
                if (--self.openRootNodesCount === 0)
                    self.allRootNodesAreCollapsed();
            });
    };

    TreeView.prototype.triggerRowEvents = function(baseEventName, tabulatorRow) {
        var data = tabulatorRow.getData();
        var $el = $(tabulatorRow.getElement());
        var eventArg = data._eventArg;
        var typePrefix = $el.hasClass('tabulator-leaf') ? 'leaf' : 'expandableNode';

        this.triggerEventIfEnabled(baseEventName, eventArg, $el);
        this.triggerEventIfEnabled(`${typePrefix}${capitalize(baseEventName)}`, eventArg, $el);
    };

    TreeView.prototype.allRootNodesAreCollapsed = function () {
        this.triggerEventIfEnabled("allRootNodesAreCollapsed");
    };

    TreeView.prototype.someRootNodesAreExpanded = function () {
        this.triggerEventIfEnabled("someRootNodesAreExpanded");
    };

    TreeView.prototype.resizeTree = function () {
        if (!this.tableInstance) return;
        this.tableInstance.setHeight(this.$element.height());
    };

    TreeView.prototype.preRender = function () {
        var self = this;
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.datasourceListenerId = this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data, isUpdate) {
                self.setData(data, isUpdate);
            }
        );

        this.initializeTree();

        this.formatters = _.map(this.data.columns, function (column) {
            return self.piping.formatting.createFormatter(column.formatting);
        });

        Required.prototype.addRemoveRequiredIndicator(self);
        this.applyPosition();
    };

    TreeView.prototype.applyFilter = function (value, key) {
        value ? this.activeFilters[key] = value : delete this.activeFilters[key];

        if (!this.tableInstance) return;

        this.performFiltering();
    };

    TreeView.prototype.performFiltering = function () {
        if (_.isEmpty(this.activeFilters)) {
            this.tableInstance.clearFilter(true);
            this.tableInstance.redraw(true);
            return;
        }

        var self = this;
        this.tableInstance.setFilter(function (row) {
            return self.checkNodeAndChildren(row);
        });

        this.tableInstance.redraw(true);
    };

    TreeView.prototype.checkNodeAndChildren = function(row) {
        var rowMatches = _.every(this.activeFilters, function(val, key) {
            var text = row._searchCache?.[key] || '';
            return text.includes(val.toLowerCase());
        });

        row._filterMatch = rowMatches;

        if (rowMatches) return true;

        if (!this.data.hideUnmatchedRows && row._parent) {
            row._ancestorMatch = row._parent._filterMatch || row._parent._ancestorMatch;
            if (row._ancestorMatch) return true;
        }

        var self = this;
        return _.some(row._children || [], function(child) {
            return self.checkNodeAndChildren(child);
        });
    };

    TreeView.prototype.postRender = function () {};

    TreeView.prototype.setData = function (data, isUpdate) {
        var self = this;

        var idProperty = this.data.idProperty;
        var parentIdProperty = this.data.parentIdProperty;
        var canHaveChildrenProperty = this.data.canHaveChildrenProperty;
        var eventArgKey = this.data.eventArg;

        if (isUpdate) {
            var idsToUpdate = _.pluck(data.results, idProperty);

            if (idsToUpdate.length === 0) return;

            this.walkTree(this.tableInstance.getRows(), rowToUpdate => {
                if (idsToUpdate.includes(rowToUpdate.getData().id)) {
                    var rowData = _.find(data.results, row => {
                        return row[idProperty] === rowToUpdate.getData().id;
                    });
                    var treeViewItemUpdate = {
                        _backgroundColors: []
                    };

                    if (eventArgKey)
                        treeViewItemUpdate._eventArg = rowData[eventArgKey];

                    self.updateColumnForRow(rowData, data, treeViewItemUpdate, rowToUpdate);

                    rowToUpdate.update(treeViewItemUpdate);
                }
            });
            return;
        }

        var treeViewItems = [];
        var treeViewItemsById = {};
        var rootTreeViewItems = [];

        _.each(data.results, function (row) {
            var treeViewItem = {
                id: row[idProperty],
                parentId: row[parentIdProperty],
                _backgroundColors: []
            };

            if (eventArgKey)
                treeViewItem._eventArg = row[eventArgKey];

            self.generateColumnsForRow(row, data, treeViewItem);

            if (canHaveChildrenProperty) {
                if (row[canHaveChildrenProperty])
                    treeViewItem._children = [];
            } else {
                treeViewItem._children = [];
            }

            treeViewItems.push(treeViewItem);
            treeViewItemsById[treeViewItem.id] = treeViewItem;

            if (!treeViewItem.parentId)
                rootTreeViewItems.push(treeViewItem);
        });

        _.each(treeViewItems, function (treeViewItem) {
            if (treeViewItem.parentId) {
                var parentTreeViewItem = treeViewItemsById[treeViewItem.parentId];
                parentTreeViewItem._children.push(treeViewItem);
                treeViewItem._parent = parentTreeViewItem;
            }
        });

        if (!canHaveChildrenProperty) {
            _.each(treeViewItems, function (treeViewItem) {
                if (treeViewItem._children && treeViewItem._children.length === 0) {
                    delete treeViewItem._children;
                }
            });
        }

        this.openRootNodesCount = this.data.expandTreeOnLoad
            ? _.filter(rootTreeViewItems, function (n) {
                return n._children != null;
            }).length
            : 0;

        this.tableInstance.replaceData(rootTreeViewItems);
    };

    TreeView.prototype.generateColumnsForRow = function (row, data, treeViewItem) {
        var self = this;
        var searchCache = {};
        var pendingMergeNodes = [];
        _.each(self.data.columns, function (column, colIndex) {
            if (self.mergesIntoNextColumn(column, colIndex)) {
                var cellEl = self.getHTMLCellElementByType(data.outputs, row, column);
                if (row[column.queryVisible] != null && !row[column.queryVisible])
                    cellEl.style.display = 'none';

                self.applyMergedItemWidth(cellEl, column);
                pendingMergeNodes.push(cellEl);

                treeViewItem._backgroundColors.push(row[column.backgroundColor]);
                return;
            }

            var baseEl = self.getHTMLCellElementByType(data.outputs, row, column);
            var cellEl = baseEl;

            if (hasContent(pendingMergeNodes)) {
                var $wrapper = $('<div class="tabulator-merged-wrapper"/>');
                self.applyMergedItemWidth(baseEl, column);

                _.each(pendingMergeNodes, function (node) {
                    $wrapper.append(node);
                });
                $wrapper.append(baseEl);

                cellEl = $wrapper[0];
                pendingMergeNodes.length = 0;
            }

            if (column.autoSpanEnabled)
                $(cellEl).addClass('tabulator-auto-span-cell');

            if (row[column.queryVisible] != null)
                $(cellEl).toggleClass('tabulator-hidden-content', !row[column.queryVisible]);

            treeViewItem[String(colIndex)] = cellEl;

            treeViewItem._backgroundColors.push(row[column.backgroundColor]);

            if (column.useTextFilter) {
                var raw = row[column.output] ?? '';
                searchCache[String(colIndex)] = raw.toLowerCase();
            }
        });

        treeViewItem._searchCache = searchCache;
    };

    TreeView.prototype.updateColumnForRow = function (row, data, treeViewItem, rowToUpdate) {
        var self = this;
        var searchCache = {};
        var rowToUpdateData = rowToUpdate.getData();

        _.each(self.data.columns, function (column, colIndex) {
            var cell = rowToUpdateData[String(self.mergesIntoNextColumn(column, colIndex) ? colIndex + 1 : colIndex)];

            switch (column.type) {
                case 'Dynamic Text':
                    var output = column.output;
                    var raw = row[output] ?? '';
                    var value = self.formatters[_.indexOf(self.data.columns, column)].convertFromLicquidFormat(data.outputs[output], raw);

                    var textEl = cell.classList.contains('tabulator-text') ? cell : cell.querySelector('.tabulator-text');
                    if (textEl && textEl.textContent !== value)
                        textEl.innerHTML = html.sanitize(value);

                    if (column.useTextFilter)
                        searchCache[String(colIndex)] = raw.toLowerCase();

                    break;
                case 'Dynamic Image':
                    var value = row[column.physicalFile];
                    var imageUrl = null;

                    if (value) {
                        imageUrl = dynamicContentImage.getPath({
                            imageName: value,
                            useThumbnail: true,
                            resizeOption: 'fillKeepRatio',
                            thumbnailFileType: 'png',
                            size: {
                                x: column.imageWidth,
                                y: column.imageHeight
                            }
                        });
                    }

                    var imgEl = cell.classList.contains('tabulator-image') ? cell : cell.querySelector('.tabulator-image');
                    var newUrl = `url("${imageUrl}")`;
                    if (imgEl && imgEl.style.backgroundImage !== newUrl)
                        imgEl.style.backgroundImage = newUrl;

                    break;

                case 'Conditional Image':
                    var output = column.output;
                    var value = row[output];
                    var imageUrl = null;

                    if (column.truePhysicalFile && column.falsePhysicalFile)
                        imageUrl = lq.getTenantUploads((value ? column.truePhysicalFile : column.falsePhysicalFile))

                    var imgEl = cell.classList.contains('tabulator-image') ? cell : cell.querySelector('.tabulator-image');
                    var newUrl = imageUrl ? `url("${imageUrl}")` : '';
                    if (imgEl && imgEl.style.backgroundImage !== newUrl)
                        imgEl.style.backgroundImage = newUrl;

                    break;
            }

            if (row[column.queryVisible] != null)
                $(cell).toggleClass('tabulator-hidden-content', !row[column.queryVisible]);

            if (column.tooltip && column.tooltip.option === Tooltip.query)
                cell.setAttribute('title', html.strip(row[column.tooltip.datasourceOutput]));

            treeViewItem._backgroundColors.push(row[column.backgroundColor]);
        });

        treeViewItem._searchCache = searchCache;
    };

    TreeView.prototype.getHTMLCellElementByType = function (outputs, row, column) {
        var self = this;
        var columnType = column.type;
        var output = column.output;

        switch (columnType) {
            case 'Static Text':
                return this.createTextContent(column, column.output, row);

            case 'Dynamic Text':
                var colType = outputs[output];
                var value = self.formatters[_.indexOf(self.data.columns, column)].convertFromLicquidFormat(colType, row[output]);
                return this.createTextContent(column, value, row);

            case 'Static Image':
                return this.createImageContent(column, null, row, false);

            case 'Dynamic Image':
                var value = row[column.physicalFile];
                var imageUrl = null;

                if (value) {
                    imageUrl = dynamicContentImage.getPath({
                        imageName: value,
                        useThumbnail: true,
                        resizeOption: 'fillKeepRatio',
                        thumbnailFileType: 'png',
                        size: {
                            x: column.imageWidth,
                            y: column.imageHeight
                        }
                    });
                }

                return this.createImageContent(column, imageUrl, row, false);

            case 'Conditional Image':
                var value = row[output];
                var imageUrl = null;

                if (column.truePhysicalFile && column.falsePhysicalFile)
                    imageUrl = lq.getTenantUploads((value ? column.truePhysicalFile : column.falsePhysicalFile))
                return this.createImageContent(column, imageUrl, row, true);
        }
    };

    TreeView.prototype.createTextContent = function(column, value, row) {
        var $content = this.createBaseContent(column, row).addClass('tabulator-text');

        if (hasContent(column.eventing))
            $content.addClass('tabulator-text-column-event');

        if ($content.attr('title') === null)
            $content.attr('title', html.strip(value || column.output));

        if (value && column.textSuffix) value += column.textSuffix;

        this.applyColumnStyleToElement($content, column);

        $content.html(value ? html.sanitize(value) : '');

        return $content[0];
    };

    TreeView.prototype.createImageContent = function(column, imageUrl, row, isConditional = false) {
        var $content = this.createBaseContent(column, row);

        if (hasContent(column.eventing))
            $content.addClass('tabulator-event');

        if (imageUrl || column.physicalFile) {
            var $image = this.create$image(column, imageUrl);
            this.addImageToContent($image, $content, column);

            if (isConditional) {
                $image.on('click', function () {
                    this.toggleConditionalState(column, row, $image);
                    return false;
                }.bind(this));
            } else {
                if (column.physicalFile && !imageUrl) setBackgroundImage($image, column.physicalFile);

                this.attachClickEvent($image, column, row);
            }

            if (column.imageVisibility === 'Hover/Selected')
                $image.addClass('tabulator-hover-image');
        }

        return $content[0];
    };

    TreeView.prototype.createBaseContent = function(column, row) {
        var $content = $('<span/>');
        $content.css({
            padding: this.getPaddingFormat(column.customPadding)
        });

        this.applyTooltip($content, column, row);
        return $content;
    };

    TreeView.prototype.applyTooltip = function($element, column, row) {
        if (!column.tooltip) return;

        if (column.tooltip.option === Tooltip.hardcoded && column.tooltip.hardcodedTooltip)
            $element.attr('title', html.strip(column.tooltip.hardcodedTooltip));
        else if (column.tooltip.option === Tooltip.query)
            $element.attr('title', html.strip(row[column.tooltip.datasourceOutput]));
    };

    TreeView.prototype.attachClickEvent = function($element, column, row) {
        var self = this;

        if (this.designData || !column.eventing) 
            return;

        $element.on('click', function () {
            self.triggerCellEventsIfEnabled('clicked', column, row[self.data.eventArg], $element);
            return false;
        });
    };

    TreeView.prototype.triggerCellEventsIfEnabled = function(baseEventName, column, eventArg, $source) {
        var $rowElement = $source.closest('[role="row"]');
        var typePrefix = $rowElement.hasClass('tabulator-leaf') ? 'leaf' : 'expandableNode';

        if (column.eventing[baseEventName] && column.eventing[baseEventName].enabled)
            this.triggerEvent(column.eventing[baseEventName].raisedEventName, eventArg, $source);

        var nodeSpecificEventName = `${typePrefix}${capitalize(baseEventName)}`;
        if (column.eventing[nodeSpecificEventName] && column.eventing[nodeSpecificEventName].enabled)
            this.triggerEvent(column.eventing[nodeSpecificEventName].raisedEventName, eventArg, $source);
    };

    TreeView.prototype.applyColumnStyleToElement = function ($element, column) {
        $element.css({
            'font-weight': column.textBold ? 'bold' : 'normal',
            'text-decoration': column.textUnderline ? 'underline' : '',
            'font-style': column.textItalic ? 'italic' : ''
        });
    };

    TreeView.prototype.toggleConditionalState = function (column, row, $div) {
        if (!this.designData && column.eventing)
            this.triggerCellEventsIfEnabled('clicked', column, row[this.data.eventArg], $div);

        if (column.enableConditionalState) {
            var currentValue = row[column.output];

            if (currentValue && (column.conditionalState === 'falseState' || column.conditionalState === 'opposite')) {
                if (!this.designData && column.eventing)
                    this.triggerCellEventsIfEnabled('unchecked', column, row[this.data.eventArg], $div);

                row[column.output] = false;
            } else if (!currentValue && (column.conditionalState === 'trueState' || column.conditionalState === 'opposite')) {
                if (!this.designData && column.eventing)
                    this.triggerCellEventsIfEnabled('checked', column, row[this.data.eventArg], $div);

                row[column.output] = true;
            }
            $div.css('background-image', "url(" + lq.getTenantUploads((!currentValue ? column.truePhysicalFile : column.falsePhysicalFile)) + ")");
        }
    };

    TreeView.prototype.getPaddingFormat = function (padding) {
        if (!padding)
            return '';
        return padding.top + 'px ' + padding.right + 'px ' + padding.bottom + 'px ' + padding.left + 'px';
    };

    TreeView.prototype.addImageToContent = function ($image, $content, column) {
        $content
            .css({
                display: 'flex',
                justifyContent: horizontalAlignmentToFlex[column.horizontalAlign]
            })
            .append($image);
    };

    TreeView.prototype.create$image = function (column, imageUrl) {
        var $image = $('<div class="tabulator-image"/>')
            .css({
                "width": column.imageWidth + "px",
                "height": column.imageHeight + "px",
                "background-image": "url(" + imageUrl + ")"
            });

        if (column.selectedResizeOption === 'stretch') {
            $image
                .css({
                    "background-size": column.imageWidth + "px " + column.imageHeight + "px",
                    "background-position": "left top"
                });
        } else if (column.selectedResizeOption === 'fillKeepRatio') {
            $image
                .css({
                    "background-size": "cover",
                    "background-position": 'center'
                });
        } else if (column.selectedResizeOption === 'completeImageKeepRatio') {
            $image
                .css({
                    "background-size": "contain",
                    "background-position": 'center'
                });
        }

        $image
            .css({
                "border-radius": column.imageRoundness + "px",
                "display": "inline-block",
                "background-repeat": "no-repeat"
            });

        return $image;
    };

    TreeView.prototype.licquidMethod_expandAllRows = function () {
        this.tableInstance.blockRedraw();
        try {
            this.tableInstance.options.dataTreeStartExpanded = true;
            this.tableInstance.replaceData(this.tableInstance.getData());
        } finally {
            this.tableInstance.restoreRedraw();
        }
    };

    TreeView.prototype.licquidMethod_collapseAllRows = function () {
        this.tableInstance.blockRedraw();
        try {
            this.tableInstance.options.dataTreeStartExpanded = false;
            this.tableInstance.replaceData(this.tableInstance.getData());
        } finally {
            this.tableInstance.restoreRedraw();
        }
    };

    TreeView.prototype.walkTree = function (rows, fn) {
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            var result = fn(row);

            if (result) return result;

            var children = row.getTreeChildren();
            if (children && children.length > 0) {
                var childResult = this.walkTree(children, fn);
                if (childResult) return childResult;
            }
        }

        return null;
    };

    TreeView.prototype.setValue = function (update) {
        var wanted = new Set(Array.isArray(update.value) ? update.value : [update.value]);

        this.walkTree(this.tableInstance.getRows(), row => {
            wanted.has(row.getData().id) ? row.select() : row.deselect();
        });
    };

    TreeView.prototype.getValue = function () {
        return _.map(this.tableInstance.getSelectedData(), item => item.id);
    };

    TreeView.prototype.clearValue = function () {
        this.walkTree(this.tableInstance.getRows(), row => row.deselect());
    };

    TreeView.prototype.isTextColumn = function (column) {
        return column.type === 'Static Text' || column.type === 'Dynamic Text';
    };

    TreeView.prototype.isMobileLayout = function () {
        return this.data.mobileFriendlyLayout === true;
    };

    TreeView.prototype.mergesIntoNextColumn = function (column, colIndex) {
        if (!column) return false;
        if (column.mergeColumn) return true;
        if (!this.isMobileLayout()) return false;
        return !!this.data.columns?.[colIndex + 1]?.mobileSameLine;
    };

    TreeView.prototype.getTreeControlColumnIndex = function () {
        var columns = this.data.columns;
        if (!columns || !columns.length) return 0;
        var index = this.data.treeControlColumn || 0;
        while (index < columns.length && this.mergesIntoNextColumn(columns[index], index))
            index++;
        return index;
    };

    TreeView.prototype.getRowDepth = function (row) {
        var parent = row.getTreeParent();
        return parent ? this.getRowDepth(parent) + 1 : 0;
    };

    TreeView.prototype.applyMobileIndent = function (row) {
        var treeField = String(this.getTreeControlColumnIndex());
        var indent = this.getRowDepth(row) * this.data.childIndent + 'px';

        if (row.getData()._children)
            indent = 'calc(' + indent + ' + var(--lq-tree-control, 0px))';

        _.each(row.getCells(), function (cell) {
            if (cell.getColumn().getField() === treeField) return;

            var content = cell.getElement().firstElementChild;
            if (content) content.style.marginLeft = indent;
        });
    };

    TreeView.prototype.applyMergedItemWidth = function (el, column) {
        if (!this.isMobileLayout()) return;

        el.style.flex = column.columnSizeType === 'pixels'
            ? '0 0 ' + column.columnSize + 'px'
            : (column.columnSize || 1) + ' 1 0';
    };

    TreeView.prototype.unsubscribeEventHandlers = function () {
        if (this.datasourceListenerId)
            this.piping.datasources
                .unregisterDatasourceListener(this.datasourceListenerId);

        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }

        if (this.tableInstance) {
            this.$tree.empty();
            this.tableInstance.destroy();
            this.tableInstance = null;
        }
    };

    return TreeView;
});

